var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamparita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 79,
    viewBox: "0 0 55 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 71.1H39.2857V79H15.7143V71.1ZM46.7736 46.2624C50.82 41.4987 55 36.5731 55 27.65C55 12.4069 42.6604 0 27.5 0C12.3396 0 0 12.4069 0 27.65C0 36.6758 4.19178 41.5856 8.25393 46.3335C9.66036 47.9846 11.1179 49.695 12.5125 51.6621C13.0782 52.4758 14.0054 55.5963 14.8343 59.25H11.7857V67.15H43.2143V59.25H40.1736C41.0104 55.5884 41.9414 52.4599 42.5032 51.6463C43.8861 49.6594 45.3554 47.9333 46.7736 46.2624ZM36.0721 47.1038C34.3671 49.5409 32.945 55.3 32.12 59.25H22.8839C22.0629 55.2921 20.6368 49.5212 18.9121 47.084C17.438 45.0471 15.8701 43.0805 14.2136 41.1906C10.3871 36.7113 7.85714 33.7488 7.85714 27.65C7.85714 16.7598 16.6689 7.9 27.5 7.9C38.3311 7.9 47.1429 16.7598 47.1429 27.65C47.1429 33.658 44.6168 36.6323 40.7982 41.1314C39.3329 42.8615 37.6711 44.8167 36.0721 47.1038Z",
    fill: "#DA0067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamparita);
export default __webpack_public_path__ + "static/media/lamparita.a750d7fbcddab942a4799f763e072434.svg";
export { ForwardRef as ReactComponent };